export const  UserPermissions = {
    SearchWithCriteria: "SearchWithCriteria",
    DownloadDocument: "DownloadDocument",

    SelectNewDocument: "SelectNewDocument",
    ChangeMailingFrequency: "ChangeMailingFrequency",
    SeeHiddenDocument: "SeeHiddenDocument",
    SeeUploadedDocuments: "SeeUploadedDocuments",
    SeeViewedDocument: "SeeViewedDocument",
    DeleteViewedDocument: "DeleteViewedDocument",
    ArchiveDocument: "ArchiveDocument",
    DeleteDocument: "DeleteDocument",
    ChangeTheme: "ChangeTheme"
}